var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurguerMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8374 23.7635C4.8374 22.6892 5.70829 21.8183 6.78258 21.8183H41.7957C42.87 21.8183 43.7409 22.6892 43.7409 23.7635C43.7409 24.8378 42.87 25.7087 41.7957 25.7087H6.78258C5.70829 25.7087 4.8374 24.8378 4.8374 23.7635Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8374 12.0924C4.8374 11.0181 5.70829 10.1473 6.78258 10.1473H41.7957C42.87 10.1473 43.7409 11.0181 43.7409 12.0924C43.7409 13.1667 42.87 14.0376 41.7957 14.0376H6.78258C5.70829 14.0376 4.8374 13.1667 4.8374 12.0924Z",
    fill: "#374151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8374 35.4346C4.8374 34.3603 5.70829 33.4894 6.78258 33.4894H41.7957C42.87 33.4894 43.7409 34.3603 43.7409 35.4346C43.7409 36.5088 42.87 37.3797 41.7957 37.3797H6.78258C5.70829 37.3797 4.8374 36.5088 4.8374 35.4346Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurguerMenuIcon);
export default __webpack_public_path__ + "static/media/burguer-menu-icon.9c06944a21da379053f86e27e89bf00b.svg";
export { ForwardRef as ReactComponent };